<template>

<header>
  <div class= "d-flex justify-content-between align-items-center ">

<!-- Maintenance -->
    <!-- <b-row v-if="inMaintenance === 'true'" align-h="center" style="text-align: center">
      <b-alert style="width: 80%" :show="true" variant="warning"><b>Site en maintenance</b> : les performances du site peuvent être dégradées</b-alert>
    </b-row> test test
Fin maintenance -->


    <div class="logo"> 
        <b-img :src="require('./../assets/logoc2i.png')"  style="height: 80px"></b-img>
    </div>

    <div class=titre>
        <h4><span><b-img :src="require('./../assets/monde.png')" style="height: 60px"></b-img> Géolocalisation des clients</span></h4>
    </div>

    <div class=" d-flex flex-column align-items-center user-wrapper">
        <div v-if="salesforceUser !== null">
          <span class="user">{{ salesforceUser.displayName }}</span>
        </div>
     
        <div class="deco">
          <button class="deco btn btn-light " v-if="isSalesforceAuthenticated"  @click="logout">
          Déconnexion
          </button>
           <a class="co btn btn-light" v-else :href="salesforceUrl">Connexion</a>
        </div>

     </div>

  </div>
  
  </header> 
  




 
 
</template>

<script>
  import { mapGetters } from 'vuex'

  let conf;
  if(process.env.NODE_ENV === 'production') {
    conf = require('../../config_prod.json');
  } else {
    conf = require('../../config_test.json');
  }

  export default {
    name: 'Header',
    props: {
      inMaintenance: {
        type: String,
        default: process.env.VUE_APP_MAINTENANCE
      },
    },
    data() {
      return {
        salesforceUrl : conf.salesforceUrl,
      }
    },
    computed: {
      ...mapGetters(['salesforceUser', 'isSalesforceAuthenticated']),
    },
    methods: {
      async logout() {
        await this.$store.dispatch('salesforceLogout',{});
        await this.$router.push('/');
      }
    }
  }
</script>

<style scoped>

header{
  background-color:#009DE0 ;
  color: white!important;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);

}

.user-wrapper{
  display: inline-block;
  margin-left: 10px; 
  padding-right: 15px;
}

.deco button{
  border-radius: 10px;
  font-size: .8rem;
  

}

.co {
  border-radius: 10px;
  font-size: .9rem;
  

}

.user{
  font-weight: bold;
}

.logo img{
  margin-left:15px;
}

@media screen and (max-width: 480px) {

  .logo img{
    margin:0!important;
    
  }

  .user-wrapper{
    margin-left:2px;
  }
  
}


</style>